<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch4" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="CT"><span aria-label="6" id="pg_6" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch4" id="ch4" title="Link target outside of Sample"><b><i>Understand</i></b></span></span></h1>
</header>
<blockquote>
<p class="V">I’m standing in a palatial courtroom that</p>
<p class="V">dates back before the Civil War. The smell of</p>
<p class="V">160 years of furniture polish and cleaning</p>
<p class="V">solutions weighs heavily in my lungs, and I</p>
<p class="V">try in vain not to breathe in through my nose.</p>
<p class="V">Their odor has not disinfected the permanence</p>
<p class="VSB">of all the souls who have stood here before me.</p>
<p class="V"><i>I feel them.</i> I hear them warning me, telling</p>
<p class="V">me there is a deadly fight before me. At this</p>
<p class="VSB">point, I am just numb.</p>
<p class="V">It’s taken me sixteen years to get here, and</p>
<p class="V">can any battle compare to what has led me</p>
<p class="V">here? I’ve reached a point where nothing else</p>
<p class="V">matters except my sanity, and most days I</p>
<p class="VSB">cannot find any evidence of that either.</p>
<p class="V">I hear the judge say my name, and I look up</p>
<p class="V">into eyes that are curious and searching—</p>
<p class="V">and a flicker of hope begins to burn within</p>
<p class="VSB">my chest.</p>
<p class="V">Not like the time he held me against the wall</p>
<p class="V">with one arm for fifteen minutes, and I</p>
<p class="V">couldn’t wear a bra for three weeks because</p>
<p class="V">my insides burned so badly. <i>Not that kind of</i></p>
<p class="V"><i>burn.</i> But I feel an authentic, hopeful flame</p>
<p class="V">burning within me. Maybe, just maybe, she will</p>
<p class="V">be the one to understand.</p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?0eeeb4d6